import FullPageLayout from '@/core/layouts/FullPageLayout.tsx'
import { Navigate, RouteObject } from 'react-router-dom'
import { lazy } from 'react'
import ErrorPage from '@/pages/errors/ErrorPage.tsx'

export const SECURITY_ROUTES: RouteObject[] = [
  {
    path: '',
    element: <FullPageLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <Navigate to="login" />
      },
      {
        path: 'login',
        lazy: async () => {
          const LoginPage = lazy(() => import('@/pages/login/loginPage.tsx'))
          return { element: <LoginPage /> }
        }
      },
      {
        path: 'passwordRecovery',
        lazy: async () => {
          const PasswordRecoveryPage = lazy(
            () => import('@/pages/passwordRecovery/PasswordRecoveryPage.tsx')
          )
          return { element: <PasswordRecoveryPage /> }
        }
      }
    ]
  }
]
